module.exports = __webpack_public_path__ + "img/icon04.f9aa845a.png";